import * as angular from 'angular';
import { BlipService } from './BlipService';
import MessagingHubService from './MessagingHubService';
import MessagingHubServiceHttp from './MessagingHubServiceHttp';
import { mediaModule } from '../media/index';
//
export default angular
    .module('messaginghub', [mediaModule])
    .service('MessagingHubService', MessagingHubService)
    .service('BlipService', BlipService)
    .service('MessagingHubServiceHttp', MessagingHubServiceHttp)
    .name;
